var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pProgress",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "pProgress-bar"
  }, [_c('div', {
    staticClass: "bar",
    style: {
      width: `${_vm.progress}%`
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };